import { render } from "./TwoFactorChallenge.vue?vue&type=template&id=534a76f8"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dmp/releases/1776447368/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__